module.exports = __webpack_public_path__ + "assets/img/vampire-hit.d9cf811a.png";